// Cấu hình chung cho ReactQuill

export const quillModules = {
  toolbar: {
    container: [
      [
        { header: [1, 2, 3, false] },
        "bold",
        "italic",
        "underline",
        "strike",
        { color: [] },
        { background: [] },
        "link",
        "image",
        "clean",
      ],
      [{ list: "ordered" }, { list: "bullet" }, { align: [] }, "blockquote"],
    ],
    handlers: {
      image: function () {}, // sẽ gán sau nếu cần
    },
  },
};

export const quillEditorContentStyle = `
  .ql-container {
    width: 100% !important;
    max-width: 700px !important;
    box-sizing: border-box !important;
    margin: 0 auto !important;
  }
  .ql-editor {
    max-height: 500px !important;
    overflow-y: auto !important;
    min-height: 100px;
    width: 100% !important;
    max-width: 700px !important;
    box-sizing: border-box !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    word-break: break-all !important;
  }
  .ql-editor img {
    max-height: 500px;
    max-width: 100% !important;
    width: auto;
    display: block;
    margin: 0 auto;
  }
  .ql-toolbar {
    width: 100% !important;
    max-width: 700px !important;
    box-sizing: border-box !important;
    margin: 0 auto !important;
  }
  .ql-editor p {
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    word-break: break-all !important;
  }
`;
